
















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ImageEmptyStateIcon extends Vue {
  @Prop({ default: '64' }) readonly width?: string;
  @Prop({ default: '48' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly color?: string;
  @Prop({ default: '#D3DAFC' }) readonly colorCircle?: string;
}
